import { makeAutoObservable } from "mobx";
import { PMoney } from "./PMoney";
export class PModifierItemInstance {
    constructor(params) {
        this.domain = params.domain;
        this.behaviour = params.behaviour;
        this.modifierItemType = params.modifierItemType;
        this.localizationProvider = params.localizationProvider;
        this._touched = false;
        makeAutoObservable(this);
    }
    get isVisible() {
        // NOTICE We display disabled items for UX purposes (striked out ModifierItem)
        return this.isDisabled || this.domain.isFinal;
    }
    get typeId() {
        return this.modifierItemType.id;
    }
    get instanceId() {
        return this.domain.instanceId;
    }
    touch() {
        this._touched = true;
    }
    get touched() {
        return this._touched;
    }
    get isChecked() {
        return this.domain.isSelected;
    }
    get isDisabled() {
        return this.domain.isDisabled;
    }
    select() {
        this.touch();
        this.domain.select();
    }
    get isSelected() {
        return this.domain.isSelected;
    }
    setSelected(selected) {
        this.touch();
        this.domain.setSelected(selected);
    }
    get itemQuantity() {
        return this.domain.quantity.value;
    }
    get unitPrice() {
        const itemPrice = this.domain.unitPrice;
        const p = new PMoney(this.localizationProvider, itemPrice.spectrum)
            .dualPriceValue;
        return p === null ? "" : ` (${p})`;
    }
    get canDecrement() {
        return this.domain.canDecrement;
    }
    get canIncrement() {
        return this.domain.canIncrement;
    }
    decrement() {
        this.touch();
        this.domain.decrement();
    }
    increment() {
        this.touch();
        this.domain.increment();
    }
    get itemAvailability() {
        return this.domain.unitAvailability;
    }
    get name() {
        return this.modifierItemType.name;
    }
    get photo() {
        return this.modifierItemType.photo;
    }
}
